import { Suspense } from 'react';
import { useAuth } from '@/auth/AuthProvider';
import { useNavTitle } from '@/i18n/useNavTitle';
import { PageHeader, PageSpinner, UrlTabs } from '@/ui';
import type { FeatureRoute } from './registry';

/**
 * A hub route: the route title, then its related screens as tabs (`?tab=`), showing only those the
 * admin can read. With a single readable screen there are no tabs. Tab screens render no
 * PageHeader of their own.
 */
export function HubPage({ route }: { route: FeatureRoute }) {
  const { permissions } = useAuth();
  const title = useNavTitle();
  const tabs = (route.tabs ?? []).filter((t) => permissions.canViewAny(t.resource));
  const only = tabs.length === 1 ? tabs[0] : undefined;
  return (
    <>
      <PageHeader title={title(route.title)} className="mb-2" />
      {only ? (
        <Suspense fallback={<PageSpinner />}>
          <div className="pt-2">
            <only.component />
          </div>
        </Suspense>
      ) : (
        <UrlTabs items={tabs.map((t) => ({ key: t.key, label: title(t.title), children: <t.component /> }))} />
      )}
    </>
  );
}
